import React from 'react';
import classNames from 'classnames';
import {
  WidgetProps,
} from './types';
import styles from './styles.module.scss';
import {
  images,
} from '../../../../assets/image';

const GeneralWidget: React.FC<WidgetProps> = (props: WidgetProps) => {
  const {
    defaultPaddings,
  } = props;
  return (
    <div
      className={classNames([styles.widgetContainer])}
      style={defaultPaddings}
    >
      <img
        src={props.widgetParams.imageURL ? props.widgetParams.imageURL : images.placeHolder}
        className={classNames([styles.widgetImage])}
      />
      <div
        className={classNames([styles.imageOverlay])}
      />
      <p
        className={styles.title}
      >
        {props.widgetParams.title}
      </p>
    </div>
  );
};

export default GeneralWidget;
